import { translate } from "../../Common/translations";

// Regex derived from NoSpecialCharacters.php — src/Lib/Framework/Validator/NoSpecialCharacters.php
const NO_SPECIAL_CHARS_PATTERN = /^[^<>/]+$/;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateStep1(values: { fullName: string; startDate: string }): Record<string, string[]> {
    const errors: Record<string, string[]> = {};

    const name = values.fullName.trim();
    if (!name) {
        errors.fullName = [translate("flash_messages.cannot_be_empty")];
    } else if (!NO_SPECIAL_CHARS_PATTERN.test(name)) {
        errors.fullName = [translate("flash_messages.no_special_chars")];
    }

    if (!values.startDate) {
        errors.startDate = [translate("flash_messages.cannot_be_empty")];
    }

    return errors;
}

export function validateStep2(values: {
    country: string | null;
    place: string;
    contactEmail: string;
    contactPhone: string;
}): Record<string, string[]> {
    const errors: Record<string, string[]> = {};

    if (!values.country) {
        errors.country = [translate("flash_messages.cannot_be_empty")];
    }

    const place = values.place.trim();
    if (!place) {
        errors.place = [translate("flash_messages.cannot_be_empty")];
    } else if (!NO_SPECIAL_CHARS_PATTERN.test(place)) {
        errors.place = [translate("flash_messages.no_special_chars")];
    }

    const email = values.contactEmail.trim();
    if (email && !EMAIL_PATTERN.test(email)) {
        errors.contactEmail = [translate("flash_messages.user_email_valid")];
    }

    if (!values.contactEmail.trim() && !values.contactPhone.trim()) {
        errors.contactInfo = [translate("page.admin_edit_event.add_at_least_one_contact_warn")];
    }

    return errors;
}
